import { computed, Injectable, signal } from "@angular/core";
import { VendorStateModel } from "../Dto/VendorStateModel";
import { Vendor } from "../Dto/VendorModel";
import { PaginationInfo } from "../Dto/VendorSearchResponse";
import { VendorSearchRequest } from "../Dto/VendorSearchRequest";

const initialState: VendorStateModel = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, pages: 0 },
  searchParams: { page: 1, limit: 10 },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class VendorState {
  private readonly state = signal<VendorStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setVendors(data: Vendor[], pagination: PaginationInfo): void {
    this.state.update((state) => ({ ...state, data, pagination, loading: false, error: null }));
  }

  setSearchParams(params: VendorSearchRequest): void {
    this.state.update((state) => ({ ...state, searchParams: params }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  addVendor(entity: Vendor): void {
    this.state.update((state) => ({
      ...state,
      data: [entity, ...state.data],
      pagination: { ...state.pagination, total: state.pagination.total + 1 },
    }));
  }

  updateVendor(entity: Vendor): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((item) =>
        (() => {
          if (item.id === entity.id) {
            return entity;
          }
          return item;
        })(),
      ),
    }));
  }

  removeVendor(id: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((item) => item.id !== id),
      pagination: { ...state.pagination, total: Math.max(0, state.pagination.total - 1) },
    }));
  }
}
